module.exports = __webpack_public_path__ + "img/FA_eMoney___Credit_card_logo-01.7153d70e.png";